/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { NoParametersFormBase as NoParametersForm } from './NoParameters.base.js'
